import React from 'react';
import { ContentSection, Heading, Paragraph } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { trackingService } from '../../tracking/tracking.service';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { getIsAcknowledgementPageLoaded } from '../../redux/slices/appData/app-data.selectors';
import { setAcknowledgementPageLoaded } from '../../redux/slices/appData/app-data.slice';

export const LegitimationResultPage = (): JSX.Element => {
  const { t } = useTranslation();
  const isAcknowledgementPageLoaded = useAppSelector(getIsAcknowledgementPageLoaded);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!isAcknowledgementPageLoaded) {
      trackingService.trackPageView('Acknowledgement', 'Acknowledgement');
      dispatch(setAcknowledgementPageLoaded(true));
    }
  }, []);

  return (
    <>
      <ContentSection className="u-text-center">
        <Heading level={3}> {t('legitimationPage:success:heading')} </Heading>
        <Heading level={4}> {t('legitimationPage:success:subheading')} </Heading>
        <Paragraph> {t('legitimationPage:success:paragraph')} </Paragraph>
      </ContentSection>
    </>
  );
};
